import {Component, EventEmitter, OnInit, Input, Output, OnDestroy} from '@angular/core';
import {CampaignService} from '../../../services/campaign/campaign.service';
import {UserService} from '../../../services/user.service';
import {AddInfluencersCampaign} from '../../../../models/campaign/add-influencers-campaign';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'add-influencers-to-campaign',
  templateUrl: './add-influencers-to-campaign.component.html',
  styleUrls: ['./add-influencers-to-campaign.component.scss']
})
export class AddInfluencersToCampaignComponent implements OnInit, OnDestroy {

  @Output()
  public backToPreviewInfluencerEvent = new EventEmitter<any>();
  @Output()
  public addToCampaignExecution = new EventEmitter<any>();
  @Input()
  selectedCampaign: AddInfluencersCampaign;
  @Input()
  public campaignList: any[] = [];
  @Input() isUsedToAddPost = true;

  // only use for adding post to campaign
  @Input()
  public totalSelectedPost: number;
  public addInfluencersCampaign: AddInfluencersCampaign = new AddInfluencersCampaign();
  public campaignDescription: string;

  private companyIdSubjectSubscription: Subscription;

  constructor(private campaignService: CampaignService,
              private userService: UserService) { }

  ngOnInit() {
    // default selected campaign
    if (this.selectedCampaign) {
      this.addInfluencersCampaign.campaign_id = this.selectedCampaign.campaign_id;
      this.campaignDescription = this.selectedCampaign.description;
    }
  }

  ngOnDestroy() {
    if (this.companyIdSubjectSubscription) {
      this.companyIdSubjectSubscription.unsubscribe();
    }
  }

  addToCampaign() {
    const [selectedCampaign] = this.campaignList.filter(
      (campaign) => campaign.id === this.addInfluencersCampaign.campaign_id);

    if (selectedCampaign) {
      this.addInfluencersCampaign.campaign_id = selectedCampaign.id;
      this.addInfluencersCampaign.campaign_name = selectedCampaign.name;
      this.addInfluencersCampaign.description = selectedCampaign.brief;
      this.addToCampaignExecution.emit(this.addInfluencersCampaign);
    }
  }

  backToPreviewInfluencer() {
    this.backToPreviewInfluencerEvent.emit();
  }

  onCampaignSelect(campaign) {
    if (campaign) {
      this.campaignDescription = campaign.brief;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/main/group-details/add-influencers-to-campaign/add-influencers-to-campaign.component.ts